import React, { useContext, useState } from 'react';
import profileImg from '../Images/sharjeel baig.PNG';
import htmlImg from '../Images/html5.png';
import csImg from '../Images/Cs.png';
import cssImg from '../Images/css.png';
import jsImg from '../Images/javascript.png';
import javaImg from '../Images/java.png';
import pythonImg from '../Images/python.png';
import Home from '../views/Home';
import { motion } from "framer-motion";




const Body = () => {
 
    return (
        
        <motion.div

        className='body' id="body">
<Home />
            </motion.div>
          
     );
}
 
export default Body;